// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"styles_marqueeContainer__ByoRR","overlay":"styles_overlay__Kae+F","marquee":"styles_marquee__SY63+"};